export const SupportCode = {
  102213: '必要错误，定位问题原因',
  102215: 'cur user in all studio permission',
  102216: '用户没有权限',
  102217: '权限key同步，校验失败',
  102218: '权限key同步，同步失败',

  // support系统
  102219: '脚本-服务配置同步失败',
  102220: 'support 平台删除用户失败',
  102221: 'support 平台用户添加失败',
  102222: 'support 平台用户添加失败，参数错误',
  102223: 'support验证tof登录code失败',
  102224: 'support tof登出失败',

  // support account request
  102225: '业务账号创建失败',
  102226: '业务账号记录为空',
  102227: '业务账号驳回失败',
  102228: '已经存在相同的环境在待审批或者启用中，无法在创建相同',
  102229: '流程已结束',
  102230: '审批-注册账号失败',
  102231: '审批-更新审批db失败',
  102232: '审批-创建定时任务失败',
  102233: '审批-用户组和角色创建失败',
  102234: '审批-邮件发送失败',
  102235: '审批-解析环境信息失败',
  102236: '主动释放-只允许申请人自己',
  102237: '主动释放-任务无效',
  102238: '主动释放-失败',
  102239: '主动释放-更新db任务状态和释放运行中的任务失败',
  102240: '主动释放-剔用户登录态失败',
  102241: '主动释放-删除用户权限失败',
  102242: '审批-加入工作室成员列表失败',
  102243: '主动释放-移除成员失败',
  102244: '主动释放-删除账号失败',
  102245: '主动释放-更新acc req table error',
  102246: '审批-portal url为空',
  102247: '工作室已认证, 不能删除',

  102001: '当前游戏下面环境重名',
  102002: '环境创建失败',
  102003: '获取配置失败',

  102005: '修改找不到记录',
  102006: '修改失败',
  102007: '查询key的配置失败',
  102008: '查询key失效',
  102009: '查询key失效',
  102010: '更新配置到redis失败',

  103502: '扭转到下一个状态无效',
  103503: '记录为空',
  103504: '状态更新失败',
  103505: '创建game approval审批记录失败',
  103506: '找不到game approval审批记录',
  103507: '当前用户审批失败',
  103508: '模拟myoa审批的人，无此游戏的权限',
  103509: '仅woa环境能开启myoa配置',
  103510: '拒绝需要填写原因',
  103511: '发布成功，邮件通知用户，失败',
  103512: '发布成功，创建myoa审批通知',
  103513: '邮件预览发送失败',
  103514: 'myoa关闭单据失败',
  103515: '审核通过，并且myoa开启，必须传cos的pdf文件名',
  103407: 'admin审批，企业状态非待审批状态，不可重复审批',
  103408: 'admin审批，找不到记录',
  103409: 'admin审批，记录审批失败',
  103410: 'admin审批，更新company状态失败',
  103411: 'mdm获取客户信息失败',
  103412: 'mdm解绑客户信息失败',
  103413: 'admin审批，mdm创建审批失败',
  103414: 'admin审批，找不到公司记录',
  103415: '提交企业认证失败,mdm审核次数达到上限',
  103416: 'admin审批，提交mdm修改失败',
  103417: '提交企业认证失败，已经存在相同的企业名称',
  103418: '提交企业认证失败，工作室信息不存在',
  103419: 'admin审批，消息发送失败(阻塞的)',

  102727: '创建下载物发现重复Tag',
  102728: '创建下载物发现parentTag不存在',
  102706: '当前下载物已创建版本，不支持删除',
};
